<template>
  <div v-if="userIdLoaded" class="profile">
    <div class="profile__presentation" v-if="!isEditing">
      <profile-header
        :is-current-user="isCurrentUserProfile"
        :user-id="userId"
        @toggle-public-cv="togglePublicCV"
        :user-contact-info="userContactInfo || currentUserContactInfo"
      />
      <activities
        :is-current-user="isCurrentUserProfile"
        :is-public-c-v="isPublicCV"
        :user-id="userId"
      />

      <events
        v-if="!isCurrentUserProfile || isPublicCV"
        :is-current-user="isCurrentUserProfile"
        :user-id="userId"
      />

      <delete-account v-if="isCurrentUserProfile && !isPublicCV" />
    </div>

    <div class="profile__editing" v-if="isEditing">
      <el-tabs
        v-model="activeTab"
        class="profile__editing-tabs"
        @update:modelValue="handleTabChange"
      >
        <el-tab-pane label="Personal data" name="personal-data" lazy>
          <personal-data
            :user-contact-info="currentUserContactInfo"
            @update-data="handleUpdateUserData"
          />
        </el-tab-pane>
        <el-tab-pane label="Security and entry" name="security" lazy>
          <security :user-contact-info="currentUserContactInfo" />
        </el-tab-pane>
        <el-tab-pane label="CV" name="cv" lazy>
          <edit-activities />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// data presenration components
import ProfileHeader from '@/components/profile/ProfileHeader.vue';
import Activities from '@/components/profile/Activities.vue';
import Events from '@/components/profile/Events.vue';

// edtiting data components
import PersonalData from '@/components/profile/PersonalData.vue';
import Security from '@/components/profile/Security.vue';
import EditActivities from '@/components/profile/EditActivities.vue';

import DeleteAccount from '@/components/profile/DeleteAccount.vue';

import { getUserContactInfoByUserId, getUserIdByLink } from '@/api/profile.js';
import {
  GET_DESCRIPTION,
  GET_USER_CONTACT_INFO,
} from '@/store/mutationTypes.js';
import { getSocialNetworkIconURL } from '@/api/images.js';

export default {
  name: 'UserProfile',
  components: {
    ProfileHeader,
    Activities,
    Events,
    PersonalData,
    Security,
    EditActivities,
    DeleteAccount,
  },
  data() {
    return {
      activeTab: 'personal-data',
      isPublicCV: false,
      userContactInfo: null,
      userId: null,
    };
  },
  computed: {
    link() {
      return this.$route.params.link || null;
    },
    isCurrentUserProfile() {
      const { userId } = this;
      const currentUserId = this.$store.state.user.userId;

      return userId && currentUserId && userId === currentUserId;
    },
    isEditing() {
      return this.$route.query.edit || false;
    },
    userIdLoaded() {
      return this.userId !== null;
    },
    descriptions() {
      return this.$store.state.descriptions;
    },
    currentUserContactInfo() {
      return this.$store.state.user.userContactInfo;
    },
  },
  methods: {
    async fetchUserInfo() {
      const { userId } = this;
      const { data, success } = await getUserContactInfoByUserId({ userId });

      if (success) {
        this.userContactInfo = data;
        for( let i = 0; i < this.userContactInfo?.userSocialNetworks?.length; i++ ) {
          //console.log(this.userContactInfo.userSocialNetworks[i]);
          this.userContactInfo.userSocialNetworks[i].iconURL = await getSocialNetworkIconURL({name: this.userContactInfo.userSocialNetworks[i].name});
        }
      }
    },
    togglePublicCV(newValue) {
      this.isPublicCV = newValue;
    },
    handleUpdateUserData() {
      this.$store.dispatch(GET_USER_CONTACT_INFO);
    },
    handleTabChange(newValue) {
      try {
        const { userId } = this;

          this.$router.push({
          route: 'UserProfile',
          params: {
            link: userId,
            tab: newValue,
          },
          query: {
            edit: true,
          },
          });

      } catch (error) {
        console.error("Error in handleTabChange:", error);
      }
    },
  },

  async created() {
    const { isCurrentUserProfile, currentUserContactInfo, link } = this;
    const { data } = await getUserIdByLink({ link: link });

    if (!(data && data.userId)) {
      this.$router.replace({
        name: 'NotFound',
      });
    } else {
      this.userId = data.userId;
      if (!isCurrentUserProfile) {
        this.fetchUserInfo();
      } else if (!currentUserContactInfo) {
        this.$store.dispatch(GET_USER_CONTACT_INFO);
      }

      if (
        !this.descriptions.activityType ||
        this.descriptions.activityType.length === 0
      ) {
        this.$store.dispatch(GET_DESCRIPTION, { key: 'activityType' });
      }
      if (
        !this.descriptions.activityCVLevel ||
        this.descriptions.activityCVLevel.length === 0
      ) {
        this.$store.dispatch(GET_DESCRIPTION, { key: 'activityCVLevel' });
      }
      if (
        !this.descriptions.skillLevel ||
        this.descriptions.skillLevel.length === 0
      ) {
        this.$store.dispatch(GET_DESCRIPTION, { key: 'skillLevel' });
      }
    }
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';

.profile {
  &__editing {
    .el-tabs {
      &__item {
        font-size: var(--font-size-500);
        line-height: 1.6;
        height: var(--global-dimension-size-550);
      }
    }
  }

  .el-collapse {
    border: none;
  }

  .el-collapse-item__header {
    height: auto;
    min-height: 152px;
    border: none;
  }

  .el-collapse-item {
    margin-bottom: 30px;
    border-radius: var(--border-radius-base);
    background-color: var(--color-gray-50);
    overflow: hidden;
  }

  .el-collapse-item__wrap {
    border: none;
  }
}
</style>
